import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "container-wide w-100 flex-shrink-1 flex-grow-1 d-flex flex-column",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "card p-5 mb-4" }
const _hoisted_3 = { class: "flex-shrink-0 d-flex flex-row justify-content-between align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "row flex-shrink-0 w-100 mx-0"
}
const _hoisted_5 = { class: "col-2 p-4" }
const _hoisted_6 = { class: "col-3 p-4" }
const _hoisted_7 = { class: "col-7 p-4" }
const _hoisted_8 = {
  class: "flex-shrink-1 flex-grow-1",
  style: {"min-height":"0"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "col-2 d-flex align-items-center px-4 py-3" }
const _hoisted_11 = { class: "col-3 d-flex align-items-center px-4 py-3" }
const _hoisted_12 = { class: "col-7 d-flex align-items-center px-4 py-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "p-2 p-lg-4" }
const _hoisted_16 = {
  key: 0,
  class: "mb-0 font-weight-bold"
}
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "lead" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_23 = {
  key: 2,
  class: "mt-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_translate = _resolveComponent("translate")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.entries.call?.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.projectId)
        ? (_openBlock(), _createBlock(_component_Dropdown, {
            key: 0,
            modelValue: _ctx.selectedProjectId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProjectId) = $event)),
            options: (_ctx.projects.data || []),
            filter: "",
            showClear: "",
            optionLabel: "name",
            optionValue: "id",
            label: _ctx.i18n.$gettext('Einträge nach Projekt filtern'),
            virtualScrollerOptions: { itemSize: 38, showLoader: true, loading: _ctx.projects.call?.loading },
            class: "w-100 flex-shrink-0 mb-2"
          }, null, 8, ["modelValue", "options", "label", "virtualScrollerOptions"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
          options: Object.keys(_ctx.typeDescriptions).map(k => { return { id: k, name: _ctx.typeDescriptions[k] } }),
          filter: "",
          showClear: "",
          optionLabel: "name",
          optionValue: "id",
          label: _ctx.i18n.$gettext('Einträge nach Typ filtern'),
          class: "flex-grow-1 mr-3"
        }, null, 8, ["modelValue", "options", "label"]),
        _createVNode(_component_Button, {
          class: _normalizeClass({ 'ml-auto': !!_ctx.projectId }),
          icon: "pi pi-file-pdf",
          label: _ctx.i18n.$gettext('PDF'),
          onClick: _ctx.downloadPDF
        }, null, 8, ["class", "label", "onClick"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-shrink-1 flex-grow-1 card d-flex flex-column", { 'bg-light': _ctx.breakpointUtil.isOnMobile }]),
      style: {"min-height":"0"}
    }, [
      (!_ctx.breakpointUtil.isOnMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("strong", null, [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Zeitstempel")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("strong", null, [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Auslöser")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("strong", null, [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Beschreibung")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_InfiniteList, {
          class: "h-100 w-100",
          "get-all-items": _ctx.sort((_ctx.entries.data || [])),
          "id-property": 'id',
          "auto-scroll-at-start": ""
        }, {
          element: _withCtx((props) => [
            (!_ctx.breakpointUtil.isOnMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "row list-row w-100 clickable mx-0",
                  onClick: _withModifiers(($event: any) => (_ctx.detailEvent = props.item), ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.dayjs(props.item.created).format('LLL')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(props.item.userName), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.getDescriptionForEntry(props.item)) + " ", 1),
                      (props.item.data?.changes && Array.isArray(props.item.data.changes))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.data.changes, (change) => {
                              return (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.getChangeDescription(change)), 1))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 8, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "card clickable mb-2",
                  style: {"margin":"0 2px"},
                  onClick: _cache[2] || (_cache[2] = () => {})
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    (props.item.created)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.dayjs(props.item.created).format('LLL')) + " - " + _toDisplayString(props.item.userName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.getDescriptionForEntry(props.item)), 1)
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["get-all-items"])
      ])
    ], 2),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showSidebar,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showSidebar) = $event)),
      position: 'right',
      "close-icon": false,
      modal: false,
      class: "p-sidebar-lg p-3"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Schließen'),
          onClick: _ctx.closeSidebar
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.typeDescriptions[_ctx.detailEvent.type] || _ctx.detailEvent.type), 1),
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.getDescriptionForEntry(_ctx.detailEvent)), 1),
        _hoisted_20,
        _createElementVNode("h6", null, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Wer und wann?")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, [
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [
                _createTextVNode("Benutzer")
              ]),
              _: 1
            })
          ]),
          _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.userName), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, [
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [
                _createTextVNode("Zeitstempel")
              ]),
              _: 1
            })
          ]),
          _createTextVNode(": " + _toDisplayString(_ctx.dayjs(_ctx.detailEvent.created).format('LLL')), 1)
        ]),
        (_ctx.projectForDetailsView)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
              _createElementVNode("strong", null, [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Project")
                  ]),
                  _: 1
                })
              ]),
              _createTextVNode(": "),
              _createVNode(_component_router_link, {
                class: "text-primary",
                to: '/projekte/' + _ctx.projectForDetailsView.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.projectForDetailsView.name), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.detailEvent.type === 'FILE_DOWNLOADED' || _ctx.detailEvent.type === 'FILE_UPLOADED' || _ctx.detailEvent.type === 'FILE_DELETED')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("h6", null, [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Eigenschaften der Datei")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Raum")
                    ]),
                    _: 1
                  })
                ]),
                _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.data.roomName), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Dateiname")
                    ]),
                    _: 1
                  })
                ]),
                _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.data.file), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Prüfsumme")
                    ]),
                    _: 1
                  })
                ]),
                _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.data.hash), 1)
              ])
            ]))
          : (_ctx.detailEvent.type === 'ROOM_CREATED')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("h6", null, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Raum Eigenschaften")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Raum")
                      ]),
                      _: 1
                    })
                  ]),
                  _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.data.room.name), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Beschreibung")
                      ]),
                      _: 1
                    })
                  ]),
                  _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.data.room.description), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Typ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createTextVNode(": " + _toDisplayString(_ctx.detailEvent.data.room.type === "CLIENT" ? _ctx.i18n.$gettext("Auftraggeber") : _ctx.i18n.$gettext("Auftragnehmer")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
        _createVNode(_component_Accordion, null, {
          default: _withCtx(() => [
            _createVNode(_component_AccordionTab, {
              header: _ctx.i18n.$gettext('Technische Daten zu diesem Ereignis')
            }, {
              default: _withCtx(() => [
                _createElementVNode("pre", null, [
                  _createElementVNode("code", null, "\n" + _toDisplayString(_ctx.getJsonForEntry(_ctx.detailEvent)) + "\n                  ", 1)
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.$route.path === '/audit-log')
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#breadcrumbs"
        }, [
          _createVNode(_component_Breadcrumb, {
            home: { icon: 'pi pi-home', to: '/' },
            model: _ctx.breadcrumbs
          }, null, 8, ["model"])
        ]))
      : _createCommentVNode("", true)
  ]))
}